<template>
  <div class="category-container">
    <div v-if="isSimpleCategory" class="col-sm-12 category category-simple">
      <div class="category-title">
        <strong class="tc-title" v-html="category.label"></strong>
        <pc-checkbox-button
          v-if="settings.consentButtonStyle === 'button'"
          v-model="category.consent"
          :label-on="settings.labelBtOn"
          :label-off="settings.labelBtOff"
          :disabled="category.locked_value === 1"
          @input="emitConsentChanged"
        ></pc-checkbox-button>
        <pc-checkbox-native
          v-else-if="settings.consentButtonStyle === 'checkbox'"
          v-model="category.consent"
          :disabled="category.locked_value === 1"
          @input="emitConsentChanged"
        ></pc-checkbox-native>
        <pc-leg-switch
          v-else
          class="pull-right"
          v-model="category.consent"
          :settings="settings"
          :label-on="settings.labelBtOn"
          :label-off="settings.labelBtOff"
          :locked-on="category.locked_value === 1"
          :locked-check="settings.blockedOnStyle == 1"
          @input="emitConsentChanged"
        ></pc-leg-switch>
      </div>
      <p class="category-description tc-description" v-html="category.description"></p>
      <a class="pointer" v-if="category.vendorCount > 0" @click="showRelatedVendors(category)">{{
        settings.showRelatedVendorsText || $t('showRelatedVendors')
      }}</a>
    </div>
    <div v-else class="col-sm-12">
      <div class="category-title">
        <span>
          <strong class="tc-title" v-html="category.label"></strong>
        </span>
        <a href="#">
          <small>
            <a class="pointer" v-show="allSubCategoriesOn" @click="setSubConsent(false)">{{
              settings.labelNoForAll
            }}</a>
            <a class="pointer" v-show="!allSubCategoriesOn" @click="setSubConsent(true)">{{
              settings.labelYesForAll
            }}</a>
          </small>
        </a>
      </div>
      <p class="category-description tc-description" v-html="category.description"></p>
      <ul class="sub_categories list-unstyled">
        <li class="sub_category" v-for="subCategory in category.subCategories" :key="'sub' + subCategory.id">
          <span class="tc-title" v-html="subCategory.label"></span>
          <div class="sub-category-switch">
            <pc-checkbox-button
              v-if="settings.consentButtonStyle === 'button'"
              v-model="subCategory.consent"
              :label-on="settings.labelBtOn"
              :label-off="settings.labelBtOff"
              :disabled="subCategory.locked_value === 1"
              :label-icon="subCategory.locked_value === 1 && settings.blockedOnStyle == 1"
              @input="emitConsentChanged"
            ></pc-checkbox-button>
            <pc-checkbox-native
              v-else-if="settings.consentButtonStyle === 'checkbox'"
              v-model="subCategory.consent"
              :disabled="subCategory.locked_value === 1"
              :label-icon="subCategory.locked_value === 1 && settings.blockedOnStyle == 1"
              @input="emitConsentChanged"
            ></pc-checkbox-native>
            <pc-leg-switch
              v-else
              v-model="subCategory.consent"
              :settings="settings"
              :label-on="settings.labelBtOn"
              :label-off="settings.labelBtOff"
              :locked-on="subCategory.locked_value === 1"
              :locked-check="settings.blockedOnStyle == 1"
              @input="emitConsentChanged"
            ></pc-leg-switch>
          </div>
          <div class="pointer sub-category-show-related" v-if="subCategory.vendorCount > 0">
            <a class="show-related-vendor" @click="showRelatedVendors(subCategory)">{{
              settings.showRelatedVendorsText || $t('showRelatedVendors')
            }}</a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import PcCheckboxButton from '@/components/forms/pc-checkbox-button';
import PcCheckboxNative from '@/components/forms/pc-checkbox-native';
import PcLegSwitch from '@/components/forms/pc-leg-switch';

import { i18nMixin } from 'shared/i18n/i18n-mixin';
import { eventEmitterMixin } from '@/common/messaging/event-emitter-mixin';
import { stripHtml } from '@/common/filters/strip-html';

export default {
  components: {
    PcCheckboxButton,
    PcCheckboxNative,
    PcLegSwitch,
  },
  mixins: [i18nMixin, eventEmitterMixin],
  props: {
    category: {
      type: Object,
    },
    settings: {
      type: Object,
      default: () => {},
    },
    noConsent: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      displayLegal: false,
    };
  },
  computed: {
    isSimpleCategory() {
      return !this.category.subCategories;
    },
    allSubCategoriesOn() {
      if (this.category.subCategories) {
        return this.category.subCategories.every(c => c.consent);
      }
      return false;
    },
  },
  methods: {
    stripHtml,
    setSubConsent(value) {
      for (const subCategory of this.category.subCategories) {
        subCategory.consent = value;
        this.emitConsentChanged(subCategory);
      }
    },
    showRelatedVendors(category) {
      this.$emit('show-related-vendors', { category: category, provider: 'tc' });
    },
  },
};
</script>
<style scoped lang="scss">
.tc-title {
  font-weight: 600;
  font-size: 1.4rem;
}

.sub_category {
  flex-wrap: wrap;
  .tc-title {
    text-indent: 3rem;
    flex: 3 1 auto;
  }
  .sub-category-switch {
    flex: 0 0 auto;
  }

  .sub-category-show-related {
    flex: 1 1 100%;
    .show-related-vendor {
      margin-left: 3rem;
    }
  }
}
</style>
